import { render, staticRenderFns } from "./ProductionStatusBadge.vue?vue&type=template&id=23d2ab3d&"
import script from "./ProductionStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ProductionStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports